import { useQuery } from 'react-query';
import { getCORAData } from 'src/utils/Queries';
import { CORAInput, GetCORADataResponse } from 'src/features/types/coraTypes';

export function useCORAData(input?: CORAInput) {
    return useQuery<GetCORADataResponse, Error>(
        ['cora-data', input],
        async () => {
            if (!input) {
                throw new Error('Input is required');
            }
            return await getCORAData(input);
        },
        {
            enabled: !!input && !!input.nodeIds && input.nodeIds.length > 0,
            staleTime: 0,
            cacheTime: 300000, // 5 minutes
            retry: 2,
            refetchOnWindowFocus: false
        }
    );
}
